import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Footer from "../../layout/Footer/Footer";
import Navbar from "../../layout/Navbar/Navbar";
import "./PrivacyStyles.scss";

function Privacy() {
	const { t } = useTranslation();

	useEffect(() => {
		document.title = `${t("privacy.pageTitle")} | GLuck Esports`;
		window.scrollTo(0, 0);
	}, [t]);

	const sections = t("privacy.sections", { returnObjects: true });

	return (
		<section id="privacy" className="privacy-page">
			<Navbar isVisible={true} />
			<div className="privacy__container">
				<header className="privacy__header">
					<h1>{t("privacy.title")}</h1>
					<p className="privacy__revision">{t("privacy.revision")}</p>
				</header>
				<div className="privacy__content">
					{Array.isArray(sections) &&
						sections.map((section) => (
							<article key={section.id} className="privacy__section">
								<h2>
									{section.id}. {section.heading}
								</h2>
								{section.paragraphs?.map((paragraph, index) => (
									<p key={`${section.id}-p-${index}`}>{paragraph}</p>
								))}
								{section.list?.length > 0 && (
									<ul>
										{section.list.map((item, index) => (
											<li key={`${section.id}-li-${index}`}>{item}</li>
										))}
									</ul>
								)}
								{section.closing?.map((paragraph, index) => (
									<p key={`${section.id}-c-${index}`}>{paragraph}</p>
								))}
							</article>
						))}
				</div>
			</div>
			<Footer alwaysVisible={true} />
		</section>
	);
}

export default Privacy;
